var map = {
	"./en.svg": "e850",
	"./he.svg": "72d8",
	"./logo-bg.png": "594f",
	"./logo-kamitech-dark.svg": "eed4",
	"./logo-kamitech.svg": "60e0",
	"./logo-light-sm.png": "01d0",
	"./notifications/whatsapp-failure.svg": "abd6",
	"./notifications/whatsapp.svg": "76c8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "04a7";